import { render, staticRenderFns } from "./InfopointSelect.vue?vue&type=template&id=65b49d80"
import script from "./InfopointSelect.vue?vue&type=script&lang=js"
export * from "./InfopointSelect.vue?vue&type=script&lang=js"
import style0 from "./InfopointSelect.vue?vue&type=style&index=0&id=65b49d80&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports